<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Terrain Settings</h2>
      <div class="close" (click)="cancelConfiguration()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngTerrainsForm" #ngForm="ngForm" id="terrainsForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="table-fields">
                <div>
                  <label>Directories Table</label>
                    <table>
                      <caption>
                      </caption>
                      <thead>
                        <tr>
                          <th scope="col">Name</th>
                          <th scope="col">Type</th>
                          <th scope="col">Active</th>
                          <th scope="col">Order</th>
                          <th *ngIf="(configurationController.savedTerrains$ | async)?.length > 2" scope="col"></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr mdbTableCol *ngFor="let el of configurationController.savedTerrains$ | async; let i = index"
                          (click)="selectTerrain(i);"
                          [class.highlighted]="el.isselected"
                          [class.deleted]="el.istodelete"
                        >
                          <td>{{ el.name }}</td>
                          <td>{{ configurationController.terrainTypes?.[el?.terrainTypeId - 1]?.type ?? '-' }}</td>
                          <td>{{ el.active }}</td>
                          <td>{{ el.position }}</td>
                          <td *ngIf="(configurationController.savedTerrains | async)?.length > 2"> 
                            <div class="btn" *ngIf="!isDefaultTerrain(el)">
                              <a (click)="configurationController.validateTerrain(el.id)">Validate Terrain</a>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div class="btn">
                      <a (click)="addTerrain()">Create</a>
                      <a (click)="editTerrain()">Edit</a>
                      <a (click)="deleteTerrain()">Delete</a>
                      <a (click)="moveUp()">Move Up</a>
                      <a (click)="moveDown()">Move Down</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="saveConfiguration(); ngForm.reset()" [disabled]="!ngForm.form.valid">
              Save
            </button>
            <button class="gray" (click)="cancelConfiguration()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
